module.exports = __webpack_public_path__ + "img/655be2f.png";